// extracted by mini-css-extract-plugin
module.exports = {"box":"DialogWrapper_box_D2QeY","content":"DialogWrapper_content_2yEJ-","title":"DialogWrapper_title_2Mhg-","main":"DialogWrapper_main_MYi8D","footer":"DialogWrapper_footer_2Rp4E"};